import ZuiDivider from '@zenbusiness/zui/Divider';

function Divider() {
  return (
    <ZuiDivider
      sx={(theme) => ({
        borderColor: theme.palette.border.main
      })}
    />
  );
}

export default Divider;
